import { Table, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { RetrievalResDto } from '@web/common';
import {
  MODE_KEY,
  fmtDate,
  type ActionKind,
} from './BdmRetrievalsSection.helpers';
import { ActionButton, StatusCell, TitledTable } from './RetrievalTableParts';

type Props = {
  retrievals: RetrievalResDto[];
  onAction: (retrieval: RetrievalResDto, kind: ActionKind) => void;
};

export const Part2Table = ({ retrievals, onAction }: Props) => {
  const { t } = useTranslation('nachversand');

  return (
    <TitledTable
      title={t('Panel.Section.Teil2')}
      columns={[
        t('Panel.Columns.Number'),
        t('Panel.Columns.Date'),
        t('Panel.Columns.Art'),
        t('Panel.Columns.Status'),
        t('Panel.Columns.Action'),
      ]}
    >
      {retrievals.map((r, i) => (
        <Table.Tr key={r.id}>
          <Table.Td fw="500">{`Nr. ${i + 1}`}</Table.Td>
          <Table.Td>{fmtDate(r.createdAt)}</Table.Td>
          <Table.Td>
            <Text size="14px">{t(MODE_KEY[r.retrievalMode])}</Text>
          </Table.Td>
          <Table.Td>
            <StatusCell retrieval={r} />
          </Table.Td>
          <Table.Td>
            <ActionButton retrieval={r} onAction={onAction} />
          </Table.Td>
        </Table.Tr>
      ))}
    </TitledTable>
  );
};
